/**
 * BLOCK: FAQ - Save Block
 */

import classnames from 'classnames';
import { InnerBlocks } from '@wordpress/block-editor';

export default function save(props) {
	const { className } = props;
	const {
		/* eslint-disable */
		block_id,
		/* eslint-enable */
		schema,
		enableSchemaSupport,
		equalHeight,
	} = props.attributes;

	const renderSchema = () => {
		if (true === enableSchemaSupport) {
			// Escape </script> sequences to prevent breaking out of the script tag.
			const safeSchema = schema
				? schema.replace(/<\/script>/gi, '<\\/script>')
				: '';
			return (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: safeSchema }}
				/>
			);
		}

		return null;
	};

	const equalHeightClass = equalHeight ? 'wpsp-faq-equal-height' : '';

	return (
		<div
			className={classnames(
				className,
				'wpsp-faq__outer-wrap',
				/* eslint-disable */
				`wpsp-block-${block_id}`,
				/* eslint-enable */
				`wpsp-faq-icon-${props.attributes.iconAlign}`,
				`wpsp-faq-layout-${props.attributes.layout}`,
				`wpsp-faq-expand-first-${props.attributes.expandFirstItem}`,
				`wpsp-faq-inactive-other-${props.attributes.inactiveOtherItems}`,
				equalHeightClass
			)}
			data-faqtoggle={props.attributes.enableToggle}
			role="tablist"
		>
			{renderSchema()}
			<div className="wpsp-faq__wrap wpsp-buttons-layout-wrap">
				<InnerBlocks.Content />
			</div>
		</div>
	);
}
